import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, DEFAULT_NAMESPACES, resources, SUPPORTED_LOCALES } from "./resources";

let initialized = false;

export function initI18n(locale: string = DEFAULT_LOCALE) {
    if (!initialized) {
        i18n
            .use(initReactI18next)
            .init({
                resources,
                lng: locale,
                fallbackLng: DEFAULT_LOCALE,
                ns: DEFAULT_NAMESPACES,
                defaultNS: "common",
                keySeparator: false,
                interpolation: {
                    escapeValue: false
                },
                returnNull: false
            });
        initialized = true;
    } else if (locale && i18n.language !== locale) {
        i18n.changeLanguage(locale);
    }

    return i18n;
}

export function getI18n() {
    return i18n;
}

export const t = i18n.t.bind(i18n);

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
